// src/api/table.api.ts
import { get, post, put, del } from './client';
import {
  ApiResponse,
  PaginatedResponse,
  Table,
  CreateTableDto,
  UpdateTableDto,
  TableQueryParams,
} from '../types';

// ===== Table Session helpers (sessionStorage) =====
const TABLE_TOKEN_KEY = 'tableSessionToken';

export const getTableToken = (): string | null =>
  sessionStorage.getItem(TABLE_TOKEN_KEY);

export const setTableToken = (token: string): void => {
  sessionStorage.setItem(TABLE_TOKEN_KEY, token);
};

export const clearTableToken = (): void => {
  sessionStorage.removeItem(TABLE_TOKEN_KEY);
};

// ===== API calls =====
export const tableApi = {
  // بدء جلسة طاولة — يُستدعى عند مسح QR Code
  startTableSession: (restaurantId: string, tableNumber: string) => {
    return get<ApiResponse<{ tableToken: string; tableNumber: string; restaurantId: string; expiresIn: number }>>(
      `/tables/session/start`,
      { params: { restaurantId, tableNumber } }
    );
  },

  // إنشاء طاولة جديدة
  createTable: (data: CreateTableDto) => {
    return post<ApiResponse<Table>>('/tables', data);
  },

  // الحصول على جميع الطاولات
  getAllTables: (params?: TableQueryParams) => {
    return get<PaginatedResponse<Table>>('/tables', { params });
  },

  // الحصول على طاولة بالـ ID
  getTableById: (id: string) => {
    return get<ApiResponse<Table>>(`/tables/${id}`);
  },

  // الحصول على QR Code للطاولة
  getTableQRCode: (id: string) => {
    return get<ApiResponse<{ tableNumber: string; qrCodeUrl: string; location?: string }>>(`/tables/${id}/qr`);
  },

  // تحديث طاولة
  updateTable: (id: string, data: UpdateTableDto) => {
    return put<ApiResponse<Table>>(`/tables/${id}`, data);
  },

  // حذف طاولة
  deleteTable: (id: string) => {
    return del<ApiResponse>(`/tables/${id}`);
  },
};